/**
 * Daniel coloring pages — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_bible_stories`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const danielColoringPagesPack: ToilePack = {
    slug: 'daniel-coloring-pages',
    category: 'faith',
    name: 'Daniel coloring pages',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 832, h: 1216},
    readings: [
        {key: 'vegetables', label: 'Vegetables', subject: "young Daniel and his three friends at a table choosing vegetables and water over the king's rich food"},
        {key: 'window', label: 'Praying', subject: 'Daniel kneeling to pray at his open upstairs window facing Jerusalem, as he does three times a day'},
        {key: 'lions', label: "Lions' den", subject: 'Daniel standing calm in the den among lions lying peacefully, an angel beside him closing their mouths'},
    ],
    styles: [
        {key: 'bold', label: 'Bold and simple', style: 'bold thick-outline coloring book style, one heavy uniform black line, big simple open shapes for young children', palette: 'black ink only', framing: 'The drawing centered with a wide white margin on all sides'},
        {key: 'classic', label: 'Classic', style: 'classic coloring book line art, medium uniform black line, moderate detail and open shapes for ages six to nine', palette: 'black ink only', framing: 'The full page used, the drawing centered with a white margin'},
        {key: 'detailed', label: 'Fine detail', style: 'fine-line detailed coloring page, thin uniform black line, patterned robes, leaves and waves for older children', palette: 'black ink only', framing: 'The scene held inside a plain thin rectangular border with a white margin outside it'},
    ],
    directions: ['fiery furnace', 'handwriting wall', 'night prayer'],
    directionHint: 'try: fiery furnace',
    seo: {
        title: "Daniel Coloring Pages: Vegetables, Praying, Lions' Den",
        metaDescription: "Nine Daniel coloring pages for Sunday school from the book of Daniel: the simple meal, prayer at the window and the lions' den, in three styles.",
        h1: "Daniel coloring pages: the vegetables, praying at the window, the lions' den",
        tagline: "Nine pages of Daniel's faithfulness in three scenes, each in three line weights.",
        intro: "Printable Daniel coloring pages for Sunday school and Christian homeschool, from the book of Daniel. Three scenes: Daniel and his three friends choosing vegetables and water over the king's rich food, Daniel kneeling to pray at his open window facing Jerusalem, and Daniel standing calm among peaceful lions. Each comes in bold lines for young children, classic lines for ages six to nine, and fine detail for older children. Type a different scene, and the same styles carry it.",
        useCases: [
            'a Sunday school lesson on Daniel',
            "a children's church craft table",
            'a Christian homeschool unit on Daniel',
            'a bulletin board on faithfulness',
        ],
        faq: [
            {q: 'Which parts of Daniel do these show?', a: "The meal of vegetables, the prayer at the window, and the lions' den."},
            {q: 'Are the lions shown peacefully?', a: 'Yes. The lions lie peacefully, and an angel stands beside Daniel.'},
            {q: 'Can I ask for the fiery furnace?', a: 'Yes. Type the scene you want. The request shapes the page, but a result is not promised to match it exactly.'},
            {q: 'Are the pages in color?', a: 'No. Each page is black line on white, with open shapes to color in.'},
        ],
    },
}
